import React from "react";

import { Steps } from "react-step-builder";
import CartPreview from "./CartPreview";

/**
 * Steps for cart
 * We can add more steps here ;)
 *
 * @returns
 */
const CheckoutSteps = () => {
  return (
    <div className="cart-preview-main hide-scroll-bar">
      <Steps key="logged-out">
        <div className="step">
          <CartPreview />
        </div>
      </Steps>
    </div>
  );
};

export default CheckoutSteps;
